<template>
  <div>
    <fieldset class="contacts-group" v-if="fromReport !== null">
      <legend class="contacts-group-heading">Extrait du rapport {{ fromReport.title }}</legend>

      <contact-card
        v-for="(contact, i) in fromReport.contacts" :key="i" 
        :contact="contact"
        :read-only="true"
        v-on:update-is-active="updateAreReportContactsActive"
        :show-is-active-toggle="i === fromReport.contacts.length - 1"
        :is-active-label="reportContactsActiveButtonLabel"
      ></contact-card>

    </fieldset>

    <fieldset class="contacts-group">
      <legend class="contacts-group-heading">
        <template v-if="fromReport === null">
          Contacts
        </template>
        <template v-else>
          Contacts Additionnels
        </template>
      </legend>

      <div v-if="additional.length === 0" style="height: 100px; max-width: 400px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <small class="text-muted">
          <template v-if="fromReport !== null">
            Aucun contact additionnel encore inscrit
          </template>
          <template v-else>
            Aucun contact encore inscrit
          </template>
        </small>
      </div>

      <contact-card 
        v-for="(contact, i) in additional" :key="i" 
        :contact="contact"
        v-on:save="saveContact"
        v-on:update-is-active="updateContactIsActive"
        v-on:confirm-delete-contact="confirmDeleteContact"
      ></contact-card>

      <div style="border-top: 1px solid #ddd; padding-top: 1em; margin-top: 3em;">
        <div v-show="!showNew" style="max-width: 600px; margin-bottom: 1em;">
          <div class="row">
            <div class="col-md-7">
              <div class="row">
                <div class="col-xs-offset-5" style="padding-left: 15px;">
                  <button class="btn btn-primary" v-on:click="showNew = true"><i class="fa fa-plus"></i> Ajouter</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="showNew">
          <contact-card
            ref="newContactCard" :is-new="true"
            v-on:save="addContact"
            v-on:cancel="showNew = false"
          ></contact-card>
        </div>
      </div>

    </fieldset>

    <transition name="modal" >
      <div class="modal-mask" v-show="showConfirmDeleteContact">
          <div class="modal-block modal-block">
            <section class="panel">
              <header class="panel-heading">
                  <strong>Êtes-vous certain?</strong>
              </header>
              <div class="panel-body">
                <div class="modal-wrapper">
                  <div class="modal-text">
                    <p>Êtes-vous certain de vouloir supprimer ce contact?</p>

                    <div v-if="contactToDelete">
                      {{ contactToDelete.first_name }} {{ contactToDelete.last_name }}<br>
                      {{ contactToDelete.position }}<br>
                      {{ contactToDelete.telephone }}<br>
                      {{ contactToDelete.email }}<br>
                    </div>
                  </div>
                </div>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-md-12 text-right">
                    <a class="btn btn-default" v-on:click="cancelDeleteContact">Non</a>&nbsp;&nbsp;<a class="btn btn-default" v-on:click="deleteContact">Oui</a>
                  </div>
                </div>
              </footer>
            </section>
          </div>
      </div>
    </transition>
    
  </div>
</template>

<style scoped>

.contacts-group {
  padding: 0.5rem 1.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 1em 0 2em;
}

.contacts-group-heading {
  display: inline-block;
  width: auto;
  border: none;
  font-size: 1.2em;
  color: #999;
  padding: 0 0.5em;
  margin: 0 -0.5em;
}

</style>

<script>
import axios from 'axios';
import ContactCard from '@/components/ContactCard.vue'

export default {
  components: {
    ContactCard
  },
  data: function() {
    return {
      fromReport: null,
      additional: [],
      primaryContactId: null,
      previousPrimaryContactId: null,
      showNew: false,
      showConfirmDeleteContact: false,
      deleteContactId: null
    }
  },
  computed: {
    reportContactsActiveButtonLabel() {
      const numReportContacts = this.fromReport.contacts.length
      if (numReportContacts === 1) {
        return null // use default
      }
      if (numReportContacts === 2) {
        return "Ces deux contacts actifs"
      }
      return `Ces ${numReportContacts} contacts actifs`
    },
    contactToDelete() {
      if (this.deleteContactId === null) {
        return null
      }

      return this.additional.find(contact => {
        return contact.contact_id === this.deleteContactId
      })
    }
  },
  methods: {
    refresh() {
      axios
        .get(this.$root.$data.server_base + '/api/contacts.php',
          { params: {service_provider_id: this.$route.params.service_provider_id}})
        .then(response => {
          this.fromReport = response.data.from_report
          this.additional = response.data.additional
          this.$parent.refreshRightCol()
        })
    },
    saveContact(contact, callback) {
      let data = {
        service_provider_id: this.$route.params.service_provider_id
      }

      const fields = 'contact_id is_active first_name last_name position telephone email'.split(' ')

      fields.forEach(fieldName => {
        if (contact[fieldName] !== undefined) {
          data[fieldName] = contact[fieldName]
        }
      })

      axios
        .post(this.$root.$data.server_base + '/api/contact_save.php',
          data,
          {headers:{
              'Content-Type': 'application/json',
          }})
        .then(() => {
          this.refresh()
          if (callback !== undefined && typeof callback === 'function') {
            callback()
          }
        })
    },
    addContact(contact) {
      this.saveContact(contact, () => {
        this.showNew = false
      })
    },
    updateAreReportContactsActive(unused_contact_id, is_active) {
      let data = {
        service_provider_id: this.$route.params.service_provider_id,
        are_report_contacts_active: is_active
      }

      axios
        .post(this.$root.$data.server_base + '/api/service_provider_save_report_contacts_active.php',
          data,
          {headers:{
              'Content-Type': 'application/json',
          }})
        .then(() => {
          this.refresh()
        })
    },
    updateContactIsActive(contact_id, is_active) {
      this.saveContact({
        contact_id,
        is_active
      })
    },
    updatePrimaryContact(newId) {
      if (newId === this.primaryContactId) { return }

      this.previousPrimaryContactId = this.primaryContactId
      this.primaryContactId = newId
    },
    confirmDeleteContact(contact_id) {
      this.showConfirmDeleteContact = true;
      this.deleteContactId = contact_id;
    },
    cancelDeleteContact() {
      this.showConfirmDeleteContact = false;
      this.deleteContactId = null;
    },
    deleteContact: function() {
      var data = {
        service_provider_id: this.$route.params.service_provider_id,
        contact_id:this.deleteContactId
      }
      
      axios
        .post(this.$root.$data.server_base + '/api/contact_delete.php',
          data,
          {headers:{
              'Content-Type': 'application/json',
        }})
        .then(response => {
          this.showConfirmDeleteContact = false;
          this.deleteContactId = null;
          this.refresh();
        })
    },
  },
  watch: {
    showNew(newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.$refs.newContactCard.focus()
      }
      if (newVal === false && oldVal === true) {
        if (this.primaryContactId === 'NEW') {
          // revert to previous primaryContactId
          this.primaryContactId = this.previousPrimaryContactId
        }
      }
    }
  },
  mounted() {
    this.refresh()
  }
}
</script>